import React from 'react'

const UpdateCompany = () => {
  return (
    <div>UpdateCompany</div>
  )
}

export default UpdateCompany